<template>
    <div class="index-box">
        <div class="index-title">我的活码</div>
      <el-alert
          title="温馨提醒：禁止上传违法违规内容，禁止将本功能用于违法、违规用途，一经发现立即停用活码并封停账号"
          type="error"
          effect="dark">
      </el-alert>
        <div class="code-name d-flex">
          <p>活码名称：</p>
          <span  id="liveCodeName">{{live_code_name}}</span>
          <div @click="amendName=true"  class="modify-name">修改名称</div>

          <span style="width:20px;"></span>活码短链接： {{short_url}} <span style="width:10px;"></span> <el-link type="primary" @click="copyUrl(short_url)"> 复制</el-link>
        </div>
      <div class="btn-features">

        <el-button type="primary" @click="amendVisit=true">批量修改访问上限</el-button>

        <el-popconfirm title="确定删除选中的分类吗？" @confirm="delLabel" style="margin-left: 10px">
          <el-button type="danger" slot="reference">删除选中</el-button>
        </el-popconfirm>
      </div>
      <div class="ul-mid box-sizing">
        <el-table v-loading="isLoading"  :data="tableData"  empty-text="请上传图片二维码" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="42"></el-table-column>
          <el-table-column prop="img" label="二维码缩略图" class-name="text-align">
            <template slot-scope="scope">
              <el-image style="width: 100px; height: 100px" :src="scope.row.img"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="priority" label="优先级" class-name="text-align">
          </el-table-column>

          <el-table-column prop="img_name" label="二维码名称" class-name="text-align">

          </el-table-column>
          <el-table-column prop="lose_efficacy_time" label="失效日期" class-name="text-align">
          </el-table-column>
          <el-table-column prop="upper_limit" label="访问上限" class-name="text-align">
          </el-table-column>
          <el-table-column prop="visit" label="累计扫码" class-name="text-align">
          </el-table-column>
          <el-table-column label="操作" >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="editLabel(scope.row)">修改</el-button>
              <el-button type="text" size="small" @click="delLabel(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagebar" v-show="total>5">
          <el-pagination background layout="total, prev, pager, next, jumper" :total="total" @current-change="handleCurrentPage"></el-pagination>
        </div>
      </div>

<!--      添加二维码-->
      <el-dialog title="添加二维码" :visible.sync="oldDialog" center width="400px" >
        <el-upload
            class="upload-demo"
            action=""
            :on-preview="handlePreview"
            :http-request="Upload"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :file-list="fileList"
            list-type="picture">
          <el-button size="small" type="primary">点击上传</el-button>

          <div slot="tip" class="el-upload__tip">只能上传图片文件，且不超过5mb---</div>
        </el-upload>
        <el-button type="primary" size="small" style="margin: auto"  @click="imgAccomplish">完成</el-button>
      </el-dialog>

<!--      批量修改访问量-->
      <el-dialog title="批量修改访问上限" :visible.sync="amendVisit" center width="400px">
            <span>
                <el-input v-model="visitval" clearable placeholder="请输入访问上限"></el-input>
            </span>
            <span slot="footer">
                <el-button @click="amendVisit=false">取消</el-button>
                <el-button type="primary" @click="batchamendvisit">确定</el-button>
            </span>
      </el-dialog>
<!--      修改二维-->
      <el-dialog title="修改二维码" :visible.sync="amendQRcode" center width="500px">
                <el-form :model="labelData" :rules="labelRules" ref="labelForm">
                    <el-form-item label="二维码" prop="img">
                       <el-image style="width: 100px; height: 100px" :src="labelData.img"></el-image>
                    </el-form-item>
                     <el-form-item label="二维码名称" prop="name" >
                        <el-input v-model="labelData.img_name" placeholder="请输入二维码名称"></el-input>
                    </el-form-item>
                    <el-form-item label="优先级" prop="priority">
                        <el-input v-model="labelData.priority" placeholder="1-200"></el-input>
                    </el-form-item>
                    <el-form-item label="访问上限" prop="upper_limit">
                        <el-input v-model="labelData.upper_limit"></el-input>
                        <div style="font-size: 8px ;font-weight: 10" >注：微信好友上限5000；微信群上限500，超200人群无法扫码进群</div>
                    </el-form-item>
                    <el-form-item label="失效时间" prop="lose_efficacy_time">
                            <el-date-picker
                                v-model="labelData.lose_efficacy_time"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                          </el-date-picker>
                    </el-form-item>
                </el-form>
        <span slot="footer">
                <el-button @click="amendQRcode=false">取消</el-button>
                <el-button type="primary" :loading="addLabelLoad" @click="addLabel">确定</el-button>
            </span>
      </el-dialog>
<!--      修改活码名称-->
      <el-dialog title="修改活码名称" :visible.sync="amendName" center width="400px">
            <span>
                <el-input v-model="nameval" clearable placeholder="请输入新名称"></el-input>
            </span>
        <span slot="footer">
                <el-button @click="amendName=false">取消</el-button>
                <el-button type="primary" @click="modificationNmae">确定</el-button>
            </span>
      </el-dialog>
      <div class="btn-features" style="border: 1px solid #F2F2F2;text-align: center;height: 100px;">
        <el-button type="primary" @click="oldDialog=true" icon="el-icon-circle-plus"  style="margin-top:25px;background:#08AE22;">添加二维码</el-button>
      </div>
      <div class="code-content">

        <div class="tips-upload">注：最多只能添加200个二维码</div>
        <div class="sequence-switch d-flex">
          <label for="group-huoma">
            <div class="chioce-huoma-list d-flex align-items-center cursor-pointer" >
              <input id="group-huoma" name="huomaMode" v-model="rank" value="0" type="radio" checked="" style="display: inline-block">
              <i class="checked" style="display: inline-block"></i>
              <span class="text1">
                <p>顺序切换二维码</p>
                <span>二维码访问人数到达上限后切换下一张</span>
              </span>
            </div>
          </label>
          <label for="groug-powderhuoma">
            <div class="chioce-huoma-list ml-30 d-flex align-items-center cursor-pointer">
              <input id="groug-powderhuoma"  v-model="rank" name="huomaMode" value="1" type="radio">
              <i style="display: inline-block"></i>
              <span class="text1">
                  <p>随机切换二维码</p>
                  <span>用户扫描后随机展示您上传的二维码</span>
              </span>
            </div>
          </label>
          <label for="groug-powderhuoma1">
            <div class="chioce-huoma-list ml-30 d-flex align-items-center cursor-pointer">
              <input id="groug-powderhuoma1" v-model="rank" name="huomaMode" value="2" type="radio">
              <i style="display: inline-block"></i>
              <span class="text1">
                  <p>轮询切换二维码</p>
                  <span>平均展示你的二维码</span>
              </span>
            </div>
          </label>
        </div>
        <div class="sequence-switch d-flex">
          <label for="distinctFlag">
            <div class="d-flex justify-content-between align-items-center switch-mode" style="cursor:pointer;">
              <input id="distinctFlag" type="checkbox" class="check-box" v-model="user_bound" style="opacity: 1;margin-left: 0;margin-right: 10px">
              <div>
                <p>用户定位</p>
                <span style="color: rgba(145, 145, 145, 1);font-size:12px;">每个设备扫描活码后绑定固定二维码</span>
              </div>
            </div>
          </label>
        </div>
        <button class="btn-sub mt-30" id="toManageLiveCode" @click="LiveCodeSet">确 定</button>
      </div>
    </div>

</template>

<script>
    import {client,getFileNameUUID} from "../../utils/oss";
    import QRCode from "qrcodejs2";
    export default {
        name: "MyLiveCode",
        props: {
          limit: {
            type: Number,
            default: 1
          }
        },
        data() {
          var checkpriority = (rule, value, callback) => {
            if (!value) {
              return callback(new Error('优先级不能为空'));
            }
            setTimeout(() => {
              console.log(Number(value))
              if (!Number.isInteger(Number(value))) {
                callback(new Error('请输入数字值'));
              } else {
                if (Number(value) < 1) {
                  callback(new Error('优先级不能为0'));
                } else {
                  if (Number(value) > 200){
                    callback(new Error('优先级不能大于200'));
                  }else{
                    callback();
                  }
                }
              }
            }, 1000);
          };
            return {
              newUrl: '',
              orgUrl: '',
              id: 0,
              url:"",
              nameval: '',
              visitval: 100,
              live_code_name:'',
              short_url:'',
              total: 0,
              img_count:0,
              keyword: "",
              rank: 0,
              user_bound: 0,
              uploadAvatar: "",
              is_hint: true,
              uploadHeaders: "",
              selUrlID: "",
              timeGroup: [],
              tableData: [],
              oldDialog:false,
              addLabelLoad: false,
              amendName:false,
              amendVisit:false,
              amendQRcode:false,
              isLoading: false,
              currentPage: 1,
              fileList: [],
              dataObj: {}, //存签名信息
              progress: 0, //进度条数据
              showProgress: false,
              ruleForm: {
                avatarUrl:'',
              },
              labelData: {
                id: 0,
                link_id: 0,
                img_name: "",
                img: "",
                group: 0,
                priority: 0,
                upper_limit: 0,
                lose_efficacy_time: "",
                visit: 0,
              },
              labelRules:{
                name: [
                  { required: false, message: '请输入分类名称', trigger: 'blur' },
                  { min: 1, max: 8, message: '长度在 1 到 8 个字符', trigger: 'blur' }
                ],
                upper_limit: [
                  { required: true, message: '访问上限不能为空', trigger: 'blur' },
                  { min: 1, max: 5, message: '请输入正确的访问上限量', trigger: 'blur' }
                ],
                priority: [
                  { validator: checkpriority, trigger: 'blur' }
                ]
              },
                shortId: 0,
                shortUrl: "123456789",
                isShowResult: false,
                param:'1',
                userInfo:{}
            }
        },
        mounted() {
          const id = Number(this.$route.params.id);
          if (id === 0){
            this.$router.back();
            return;
          }
          this.id = id;
          setTimeout(this.getLinkInfo,200);

        },
        methods: {

          copyUrl(txt) {
            const msg = this.$message;
            if (txt === '') {
              msg.error('复制失败！');
            }
            this.$copyText(txt).then(function (e) {
              console.log(e);
              msg.success('复制成功');
            }, function (e) {
              console.log(e);
              msg.error('复制失败！');
            });
          },
            async getLinkInfo() {
              this.isLoading = true;
              console.log(this.id)
              const {ret,data} = await this.$api.index.huoMaList({id:this.id});
              if (ret === 1000){
                this.isLoading = false;
                this.newUrl = data.newUrl;
                this.short_url = data.short_url;
                this.orgUrl = data.orgUrl;
                this.live_code_name = data.live_code_name;
                this.is_live_code = data.is_live_code;
                this.rank = data.live_code_group;
                this.user_bound = Number(data.is_user_bound);
                this.tableData = data.img_list;
                this.img_count = data.img_count;
              }
            },
            async LiveCodeSet() {
              let is_user_bound = 0

              if (this.user_bound){
                  is_user_bound = 1
              }
              const getData = {
                id:this.id,
                rank: this.rank,
                user_bound: is_user_bound
              };
              const {ret,data} = await this.$api.livecode.liveCodeSet(getData);
              if (ret === 1000) {
                // this.$message.success("转换成功");
                await this.$router.push('/tabs/liveCodeList/');
              }
            },
            addLabel() {
              const $this = this;
              $this.addLabelLoad = true;
              $this.$refs.labelForm.validate(async (valid) => {
                if (valid) {
                  let postData = {
                    id: $this.labelData.id,
                    img_name: $this.labelData.img_name,
                    lose_efficacy_time: $this.labelData.lose_efficacy_time,
                    priority: $this.labelData.priority,
                    upper_limit: $this.labelData.upper_limit,
                  };
                  const {ret} = await $this.$api.livecode.amendimg(postData);
                  $this.addLabelLoad = false;
                  if (ret === 1000){
                    $this.amendQRcode = false;
                    $this.$message.success("修改成功！");
                    await $this.getLinkInfo();
                  }
                }else {
                  $this.addLabelLoad = false;
                }
              });
            },
            delLabel(id) {
              let ids = "";
              if (id){
                ids = id;
              }else {
                ids = this.selUrlID;
              }
              this.$confirm('此操作将永久删除该二维码, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(async () => {
                const {ret} = await this.$api.livecode.dleImg({ids:ids});
                if (ret === 1000){
                  this.$message.success("删除成功！");
                  this.getLinkInfo();

                }
              });
            },

          async batchamendvisit() {
            if (Number(this.visitval) < 1) {
              this.$message.error('请输入正确的访问上限！');
              return;
            }
            const getData = {
              visitval: this.visitval,
              ids: this.selUrlID
            };
            const {ret} = await this.$api.livecode.batchVisit(getData);
            if (ret === 1000) {
              this.amendVisit = false;
              this.$message.success('设置成功');
              this.getLinkInfo();
            }
          },

          bindQRCode() {
            const txt = this.shortUrl;
            if (txt === '') return;
            this.$refs.qrCodeDiv.innerHTML = '';
            new QRCode(this.$refs.qrCodeDiv, {
              text: txt,
              width: 200,
              height: 200,
              colorDark: "#333333", //二维码颜色
              colorLight: "#ffffff", //二维码背景色
              correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
            });
          },
          //上传图片
            async Upload(file) {
              const that = this;
              const id = this.id;


              if(this.img_count > 200){
                this.$message.error('图片数量已经超过200！');
                return
              }
              // const api = this.$api;
              async function multipartUpload() {
                let temporary = file.file.name.lastIndexOf(".");
                let fileNameLength = file.file.name.length;
                let fileFormat = file.file.name.substring(
                    temporary + 1,
                    fileNameLength
                );
                  var date = new Date();
                  var year = date.getFullYear();    //  返回的是年份
                  var month = date.getMonth() + 1;  //  返回的月份上个月的月份，记得+1才是当月
                  if(month<10) month='0'+month;
                  var dates = date.getDate();       //  返回的是几号
                  if(dates<10) dates='0'+dates;
                  var day = date.getDay();          //  周一返回的是1，周六是6，但是周日是0

                that.$common.Upload(file,async function(img){
                  //上传成功返回值，可针对项目需求写其他逻辑
                  // console.log(result);
                  const getData = {
                    fileName: img,
                    id:id
                  };
                  const {ret} = await  that.$api.livecode.addimg(getData);
                  console.log(ret)
                  if (ret === 1000) {
                    that.getLinkInfo();
                    that.$message.success('添加成功');
                  }
                });
              }
              multipartUpload();
            },

            handleSuccess(response, file, fileList) {
              this.fileList = fileList;
            },
            // 上传检查图片
            beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const ispng = file.type === 'image/png';
            const isgif = file.type === 'image/gif';
            const isbmp = file.type === 'image/bmp';
            const ispdf = file.type === 'image/pdf';
            const isGIF = file.type === 'image/GIF';
            const isLt2M = file.size / 1024 / 1024 < 5;

            console.log(file.type);
            if (!isJPG && !ispng && !isgif && !isbmp && !ispdf && !isGIF) {
              this.$message.error('上传图片格式不正确!');
              return false
            }
            if (!isLt2M) {
              this.$message.error('上传图片大小不能超过 5MB!');
              return false
            }
            return isLt2M;
          },
            // 删除文件之前的钩子
            beforeRemove(file, fileList) {
              return this.$confirm(`确定移除 ${file.name}？`);
            },
            handleRemove(file, fileList) {
              console.log(file, fileList);
            },
            handlePreview(file) {
              console.log(file);
            },

            //修改二维码弹出赋值
            editLabel(item){
              this.labelData.id = item.id;
              this.labelData.img_name = item.img_name;
              this.labelData.link_id = item.link_id;
              this.labelData.img = item.img;
              this.labelData.visit = item.visit;
              this.labelData.priority = item.priority;
              this.labelData.upper_limit = item.upper_limit;
              this.labelData.lose_efficacy_time = item.lose_efficacy_time;
              this.labelData.visit = item.visit;
              this.amendQRcode = true;
            },
          handleCurrentPage(val) {
            this.currentPage = val;
            this.getLabelList();
          },
          //修改活码名称
          async modificationNmae() {
            if (this.nameval === "") {
              this.$message.error('请输入新名称！');
              return;
            }
            const getData = {
              nameval: this.nameval,
              id: this.id
            };
            const {ret,data} = await this.$api.livecode.amendNmae(getData);
            if (ret === 1000) {
              this.live_code_name = data.live_code_name;
              this.amendName = false;
              this.$message.success('设置成功');
            }
          },

          //上传图片后确定按钮
          async imgAccomplish() {
            this.oldDialog = false;
            this.fileList = [];
          },

          handleSelectionChange(val) {
            if (val.length === 0){
              return;
            }
            let ids = "";
            for (const item of val){
              ids += item.id+",";
            }
            ids = ids.substr(0,ids.length-1);
            this.selUrlID = ids;
          }
        },

    }
</script>

<style scoped>
    .index-box{
        width: 96%;
        height: auto;
        margin-left: 40px;
        padding: 30px 0px 30px 0px;
    }
    .index-box .index-title{
        width: 100%;
        height: 28px;
        font-size: 20px;
        margin-bottom: 40px;
    }
    .index-box .btn-box{
        width: 100%;
    }
    .result-box{
        width: 100%;
        height: auto;
        padding-top: 40px;
    }
    .result-box .top-ico{
        width: 840px;
        height: 40px;
        color: #07cc00;
        font-size: 24px;
        text-align: center;
        line-height: 40px;
        margin-left: 100px;
        margin-bottom: 20px;
    }
    .result-box .top-ico i{
        display: inline-block;
        font-size: 40px;
        margin-right: 10px;
        vertical-align: top;
    }
    .result-box .item{
        width: 100%;
        height: auto;
        padding-bottom: 20px;
    }
    .result-box .item .l{
        display: inline-block;
        width: 100px;
        height: 40px;
        color: #606266;
        font-size: 14px;
        text-align: right;
        line-height: 40px;
        padding-right: 12px;
        vertical-align: top;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .result-box .item .m{
        display: inline-block;
        width: 720px;
        height: 40px;
        vertical-align: top;
    }
    .result-box .item .r{
        display: inline-block;
        width: 98px;
        height: 40px;
        margin-left: 22px;
        vertical-align: top;
    }
    .result-box .item .lab{
        display: inline-block;
        width: 100px;
        color: #606266;
        font-size: 14px;
        text-align: right;
        line-height: 40px;
        padding-right: 12px;
        vertical-align: top;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .result-box .item .qrCode{
        display: inline-block;
        width: 200px;
        height: 200px;
        vertical-align: top;
    }
    .result-box .item .dl-btn{
        display: inline-block;
        width: 112px;
        height: 120px;
        margin-left: 40px;
        padding-top: 80px;
        vertical-align: top;
    }


    .clear{clear: both;}

    .about-box{margin-top: 50px;}
    .about-box .index-title2{padding: 10px 0px;font-size: 18px;color:red;}
    .about-box .about-s{width:220px;margin-right:10px;float:left;background:#f4f7f369;height:90px;margin-top: 10px;}
    .about-box .about-s .about-s-main{padding:15px;}
    .about-box .title2{font-weight: bold;padding:20px 0;}
    .about-box .about-s b{font-size:14px;font-weight: bold;color:#2d5dee;}
    .about-box i{font-size:20px;   }
    .about-box p{font-size: 14px;}
    ul{
      padding:0; list-style:none;
      margin:150px 150px;
    }
    li{
      width:80px; height:50px;
      display:inline-block;
      border-radius:8px; border:1px #000 solid;
      text-align:center; line-height:50px;
      cursor:pointer;
      transition:all 0.3s linear;
      margin-left:5px;
    }
    li:hover{
      background-color:#0CF; color:#fff;
      border:1px #fff solid;
    }
    li.checked{
      background-color:#0CF; color:#fff;
      border:1px #fff solid;
    }
    .tips-danger {
      width: 92%;
      height: 40px;
      background: rgba(255, 249, 249, 1);
      line-height: 40px;
      font-size: 14px;
      color: rgba(248, 52, 55, 1);
      font-weight: 400;
      /*padding: 0 10px;*/
      margin-top: -2px;
    }
    .tips-danger > .close {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
    .code-name {
      margin-top: 20px;
      font-size: 16px;
      margin-bottom: 30px;
    }
    .code-name .modify-name {
      font-size: 14px;
      font-weight: 400;
      color: #277cf2;
      margin-left: 11px;
    }
    button {
      border: 0 none;
      /*background-color: transparent;*/
      cursor: pointer;
    }
    .code-nav {
      width: 100%;
      height: 50px;
      background: rgba(245, 247, 246, 1);
      /*padding: 0 19px;*/
    }
    .d-flex {
       display: -webkit-box!important;
      display: -ms-flexbox!important;
       display: -webkit-flex!important;
       display: flex!important;
    }

    img {
      max-width: 100%;
      max-height: 100%;
      border: none;
      vertical-align: middle;
    }
    .code-content .code-list .btn-add span {
      font-size: 14px;
      color: #277cf2;
      margin-left: 8px;
      line-height: 34px;
    }
    .code-content .code-list:nth-last-of-type(1):hover {
      background: #ffffff;
      cursor: pointer;
    }
    .code-content .code-list:hover {
      background: rgba(245, 247, 246, 1);
      cursor: pointer;
    }
    .content-box .content {
      margin-left: 220px;
      width: calc(100% - 610px);
      min-width: 650px;
      min-height: 560px;
      padding: 27px 30px;
      background-color: #fff;
      box-shadow: 0 2px 5px rgb(0 0 0 / 5%);
      position: relative;
      font-family: PingFang-SC-Medium, PingFang-SC;
      position: relative;
    }
    button {
      writing-mode: horizontal-tb !important;
      font-style: ;
      font-variant-ligatures: ;
      font-variant-caps: ;
      font-variant-numeric: ;
      font-variant-east-asian: ;
      font-weight: ;
      font-stretch: ;
      font-size: ;
      font-family: ;
      text-rendering: auto;
      color: -internal-light-dark(black, white);
      letter-spacing: normal;
      word-spacing: normal;
      line-height: normal;
      text-transform: none;
      text-indent: 0px;
      text-shadow: none;
      text-align: center;
      cursor: default;
    }
    .code-content .code-list {
      width: 100%;
      /*padding: 20px 19px;*/
      border-bottom: 1px solid #F2F2F2;
      box-sizing: border-box;
      min-height: 146px;
    }
    .content-box .content .check-box {
      position: relative;
      width: 14px;
      height: 14px;
      border: 1px solid #C7C8CB;
      vertical-align: -8%;
    }
    .code-content .check-box {
      position: relative;
      width: 14px;
      height: 14px;
      border: 1px solid #C7C8CB;
      vertical-align: middle;
      margin-left: 10px;
    }
    .code-content .code-list .code-priority {
      width: 10%;
      text-align: center;
      line-height: 85px;
    }
    .code-content .code-list .code-thumbnail {
      width: 20%;
      text-align: center;
      line-height: 85px;
    }
    .code-content .code-list .code-thumbnail img {
      height: auto;
      max-height: 100px;
      width: auto;
    }
    .code-content .code-list .crowd-name {
      width: 20%;
      text-align: center;
      line-height: 85px;
    }
    .code-content .code-list .code-invalid-data {
      width: 20%;
      text-align: center;
      line-height: 85px;
    }
    .code-content .code-list .code-toplimit {
      width: 8%;
      text-align: center;
      line-height: 85px;
    }
    .code-content .code-list .code-operate {
      width: 8%;
      text-align: center;
      /*line-height: 85px;*/
    }
    .code-content .code-list .code-operate .btn-edit {
      margin-right: 10px;
      color: #919191;
    }
    .code-content .code-list .code-operate .btn-del {
      color: #919191;
    }
    .tips-upload {
      font-size: 12px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: rgba(145, 145, 145, 1);
      line-height: 17px;
      margin-top: 6px;
    }
    .sequence-switch {
      margin-top: 30px;
    }
    .sequence-switch div:nth-of-type(1) {
      margin-right: 88px;
    }

    .text1{
      margin-left:10px ;
    }
    .text1 p{
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .text1  span {
      display: block;
      font-size: 12px;
      font-weight: 400;
      color: rgba(145, 145, 145, 1);
      margin-top: 6px;
    }
    .sequence-switch div:nth-of-type(2) {
      margin-right: 88px;
    }
    .content-box .content .check-box {
      position: relative;
      width: 14px;
      height: 14px;
      border: 1px solid #C7C8CB;
      vertical-align: -8%;
    }
    .btn-sub {
      width: 120px;
      height: 34px;
      background: #277cf2;
      border-radius: 2px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 34px;
    }
    .mt-30 {
      margin-top: 30px;
    }
</style>
